// extracted by mini-css-extract-plugin
module.exports = {"article":"guide_article__cxmMw","pagination":"guide_pagination__uhlzl"};